var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _g, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhyKlosetIcon4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 51,
    viewBox: "0 0 65 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5567 18.8121L26.1901 12.1699C26.075 11.983 25.9538 11.8009 25.8285 11.6228L19.0312 18.4275L19.5567 18.8121Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4323 17.9899L25.3839 11.0281C25.2485 10.8616 25.1083 10.7004 24.9628 10.542L17.9082 17.6067L18.4323 17.9899Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3818 15.1477L23.3944 9.12777C23.219 8.99912 23.0402 8.87386 22.8574 8.75537L17.3825 14.2377V15.1477H17.3818Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3818 13.1997L22.2108 8.36526C22.0138 8.25625 21.8134 8.15468 21.6096 8.05786L17.3818 12.2903V13.1997Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3818 11.2516L20.8851 7.74366C20.6643 7.65835 20.4389 7.58184 20.2114 7.51074L17.3818 10.343V11.2516Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3818 9.30357L19.3948 7.28788C19.1436 7.23033 18.8877 7.18497 18.6304 7.14502L17.3818 8.3956V9.30357Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3818 17.0952L24.4506 10.0169C24.2956 9.86798 24.1378 9.72376 23.9739 9.58496L17.3818 16.1852V17.0952Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.694 7.04376C17.5897 7.03699 17.4861 7.0336 17.3818 7.02954V7.35725L17.694 7.04376Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6817 19.6348L26.8621 13.4462C26.77 13.2383 26.6718 13.0332 26.5662 12.8328L20.1562 19.2515L20.6817 19.6348Z",
    fill: "black"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9296 21.2802L27.7044 16.4993C27.6719 16.2352 27.632 15.9725 27.5812 15.7139L22.4062 20.8963L22.9296 21.2802Z",
    fill: "black"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M21.804 20.4569L27.3765 14.8777C27.3115 14.6448 27.2397 14.4139 27.1591 14.1877L21.2793 20.075L21.804 20.4569Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1787 22.9269L27.3914 20.7108C27.4977 20.331 27.583 19.9423 27.6466 19.5476L24.6553 22.543L25.1787 22.9269Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M24.054 22.1031L27.7706 18.3825C27.78 18.195 27.7861 18.0068 27.7861 17.8151C27.7861 17.698 27.7821 17.5822 27.778 17.4651L23.5293 21.7199L24.054 22.1031Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1026 23.6005C26.3551 23.2031 26.5826 22.7901 26.783 22.3601L25.7803 23.3642L26.1026 23.6005Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_159_1417",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 65,
    height: 51
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.85498H65.0002V50.6452H0V0.85498Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_159_1417)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.2415 50.6H3.75967C1.75415 50.6 0.123047 48.9662 0.123047 46.9586V4.46675C0.123047 2.45852 1.75482 0.824707 3.75967 0.824707H61.2415C63.2471 0.824707 64.8782 2.45919 64.8782 4.46675V46.9586C64.8788 48.9662 63.2471 50.6 61.2415 50.6ZM3.75967 2.2818C2.55649 2.2818 1.57743 3.26154 1.57743 4.46675V46.9586C1.57743 48.1632 2.55649 49.1436 3.75967 49.1436H61.2415C62.4447 49.1436 63.4238 48.1632 63.4238 46.9586V4.46675C63.4238 3.26154 62.4447 2.2818 61.2415 2.2818H3.75967Z",
    fill: "black"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1943 15.1621H39.9866V24.3129H37.1943V15.1621Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5273 15.9248H44.319V24.3132H41.5273V15.9248Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8574 17.4509H48.649V24.3132H45.8574V17.4509Z",
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1904 13.636H52.9821V24.3123H50.1904V13.636Z",
    fill: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5225 13.636H57.3141V24.3123H54.5225V13.636Z",
    fill: "black"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1741 30.5811L42.5138 37.7934L37.1784 34.5596L27.5543 38.939L11.9631 40.3169L5.82324 44.6868H57.1301L57.1741 30.5811Z",
    fill: "black"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9861 28.5845C11.0399 28.5845 6.20215 23.7413 6.20215 17.7863C6.20215 11.9681 10.8219 7.21157 16.5812 6.99829V17.6807H16.5866L25.6 24.2755C25.5993 24.2755 25.5993 24.2755 25.5993 24.2755C23.631 26.8904 20.5022 28.5845 16.9861 28.5845Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhyKlosetIcon4);
export default __webpack_public_path__ + "static/media/whyKlosetIcon4.e9c38ee3da1dc7b97f8f6d50c0cafdf6.svg";
export { ForwardRef as ReactComponent };